import React from 'react';
import { motion } from 'framer-motion';
import { CircleDotIcon, ExternalLinkIcon, CheckCircle2Icon, ClockIcon, ShieldCheckIcon } from 'lucide-react';
export function ContactLensOrderSection() {
  return <section className="py-20 md:py-28 bg-brand-dark relative overflow-hidden" data-id="element-133">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-134" />
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-brand-gold/5 rounded-full blur-3xl pointer-events-none" data-id="element-135" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-136">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center" data-id="element-137">
          {/* Left Content */}
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-138">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-gold/10 border border-brand-gold/20 text-brand-gold text-sm font-semibold mb-6" data-id="element-139">
              <CircleDotIcon className="w-4 h-4" data-id="element-140" />
              <span data-id="element-141">Contact Lens Orders</span>
            </motion.div>

            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-3xl md:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-142">
              Running Low on Contacts? <br data-id="element-143" />
              <span className="text-brand-gold" data-id="element-144">Order Online Easily.</span>
            </motion.h2>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-lg text-white/80 mb-10 leading-relaxed max-w-xl mx-auto lg:mx-0" data-id="element-145">
              Skip the phone call. Order your contact lens refills online
              through our secure ordering portal. Fast, convenient, and
              delivered right to your door.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3
          }} className="space-y-4 text-left max-w-md mx-auto lg:mx-0" data-id="element-146">
              <div className="flex items-start gap-3" data-id="element-147">
                <div className="w-6 h-6 rounded-full bg-brand-gold/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-148">
                  <ShieldCheckIcon className="w-3.5 h-3.5 text-brand-gold" data-id="element-149" />
                </div>
                <div data-id="element-150">
                  <h4 className="text-white font-semibold" data-id="element-151">
                    Current Prescription Required
                  </h4>
                  <p className="text-white/60 text-sm" data-id="element-152">
                    Your prescription will be verified before fulfilling.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-153">
                <div className="w-6 h-6 rounded-full bg-brand-gold/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-154">
                  <CheckCircle2Icon className="w-3.5 h-3.5 text-brand-gold" data-id="element-155" />
                </div>
                <div data-id="element-156">
                  <h4 className="text-white font-semibold" data-id="element-157">
                    Wide Selection of Brands
                  </h4>
                  <p className="text-white/60 text-sm" data-id="element-158">
                    All major brands available including Acuvue, Alcon,
                    CooperVision, and more.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-159">
                <div className="w-6 h-6 rounded-full bg-brand-gold/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-160">
                  <ClockIcon className="w-3.5 h-3.5 text-brand-gold" data-id="element-161" />
                </div>
                <div data-id="element-162">
                  <h4 className="text-white font-semibold" data-id="element-163">Quick Turnaround</h4>
                  <p className="text-white/60 text-sm" data-id="element-164">
                    Most orders ship within 2–3 business days.
                  </p>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Right CTA Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="lg:w-1/2 w-full" data-id="element-165">
            <div className="bg-white/5 backdrop-blur-md border border-white/10 p-10 md:p-14 rounded-card shadow-2xl text-center" data-id="element-166">
              <div className="w-20 h-20 bg-brand-gold/15 rounded-full flex items-center justify-center mx-auto mb-8" data-id="element-167">
                <CircleDotIcon className="w-10 h-10 text-brand-gold" data-id="element-168" />
              </div>

              <h3 className="text-2xl md:text-3xl font-heading font-bold text-white mb-4" data-id="element-169">
                Order Your Contacts Now
              </h3>
              <p className="text-white/70 mb-8 max-w-sm mx-auto leading-relaxed" data-id="element-170">
                Visit our online contact lens store to browse, reorder, and have
                your lenses shipped directly to you.
              </p>

              <a href="https://clx.com" target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2 bg-brand-gold hover:bg-brand-gold-light text-white px-10 py-4 rounded-button font-heading font-bold text-lg transition-colors shadow-lg focus-ring w-full sm:w-auto" data-id="element-171">
                Order Contact Lenses
                <ExternalLinkIcon className="w-5 h-5" data-id="element-172" />
              </a>

              <p className="text-white/40 text-sm mt-6" data-id="element-173">
                You'll be redirected to our secure ordering portal.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}